
import TownSnowParticle from './TownSnowParticle';
import { EVENTS } from '../../../shared/Events';
import ConfigScene from '../../helpers/ConfigScene';

class TownSnow {
  constructor(parentCont) {
    // const
    this.SNOW_CEIL = aPage.features.isCanvas ? 3000 : 6000;
    this.SNOW_MAX = aPage.features.isCanvas ? 2000 : 4000;
    this.SNOW_MIN = aPage.features.isCanvas ? 200 : 400;
    this.SNOW_DIFF = this.SNOW_MAX - this.SNOW_MIN;

    this.DELAY_MAX = aPage.features.isCanvas ? 180 : 90;
    this.DELAY_MIN = aPage.features.isCanvas ? 18 : 9;
    this.DELAY_DIFF = this.DELAY_MAX - this.DELAY_MIN;

    // vars
    this.parentCont = parentCont;
    this.flakeSpeed = 1;
    this.flakeLast = 0;
    this.flakeDelay = 0;
    this.flakesActive = [];
    this.flakesPool = [];

    // parts
    this.snowCont = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // set container
    this.snowCont = new PIXI.ParticleContainer(this.SNOW_CEIL, {
      scale: true,
      position: true,
      rotation: false,
      uvs: false,
      alpha: true,
    });
    this.snowCont.y = -aScene.sceneManager.offset;
    this.parentCont.addChild(this.snowCont);

    // init flakes
    this.resetFlakes();

    // signals
    aScene.signals.loopCall.add(this.loopUp, this);
    aScene.signals.sceneCallMain.add(this.callMainFc, this);
  }

  // --------------------------------------------------------------
  // Main Call
  // --------------------------------------------------------------

  callMainFc(sgType) {
    switch (sgType) {
      case EVENTS.MOVE_TO_HEAVEN_END:
        this.snowCont.visible = false;
        break;
      case EVENTS.MOVE_TO_TOWN_START:
        this.snowCont.visible = true;
        this.resetFlakes();
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Flakes
  // --------------------------------------------------------------

  resetFlakes() {
    // reset current
    this.flakesActive.forEach((flake) => {
      flake.remove();
      this.flakesPool.push(flake);
    });
    this.flakesActive = [];
    // set
    for (
      let i = 0;
      i < Math.round(this.SNOW_MIN + (this.SNOW_DIFF * aScene.sceneManager.snowMain));
      i += 1) {
      this.addFlake(true);
    }
  }

  addFlake(randomY) {
    let flake = null;
    if (this.flakesPool.length > 0) {
      flake = this.flakesPool.pop();
    } else {
      flake = new TownSnowParticle(this.snowCont);
    }
    flake.reset(randomY);
    this.flakesActive.push(flake);
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    if (aScene.sceneManager.sceneState !== 1) {
      if (aScene.sceneManager.sceneState === -1) {
        this.transitionUpdate();
      }
      this.moveFlakes();
      this.addFlakes();
    }
  }

  transitionUpdate() {
    const tempScale = 0.3 * aScene.sceneManager.townScale;
    this.snowCont.scale.x = 1 + tempScale;
    this.snowCont.scale.y = 1 + tempScale;
    this.snowCont.x = -(ConfigScene.SIZES.SCENE_WIDTH_MAX * tempScale) * 0.5;
    this.snowCont.y = -aScene.sceneManager.offset;
    this.snowCont.alpha = aScene.sceneManager.offsetProgress > 0 ? 0 :
      Math.abs(aScene.sceneManager.offsetProgress);

    this.flakeSpeed = 1 + (50 * aScene.sceneManager.townScale);
  }

  moveFlakes() {
    const movingFlakes = [];
    this.flakesActive.forEach((flake) => {
      if (flake.lUp(this.flakeSpeed)) {
        movingFlakes.push(flake);
      } else {
        this.flakesPool.push(flake);
      }
    });
    this.flakesActive = movingFlakes;
  }

  addFlakes() {
    this.flakeLast += aScene.sceneManager.msFrame;
    this.flakeDelay = (this.DELAY_MAX - (this.DELAY_DIFF * aScene.sceneManager.snowMain)) /
      this.flakeSpeed;
    while (this.flakeLast > this.flakeDelay) {
      this.flakeLast -= this.flakeDelay;
      this.addFlake(false);
    }
    if (aScene.sceneManager.sceneState === 0) {
      if (aScene.sceneManager.snowMain > 0) {
        aScene.sceneManager.snowMain -= aScene.sceneManager.msFrame / 40000;
      } else {
        aScene.sceneManager.snowMain = 0;
      }
    }
  }
}

export default TownSnow;



// WEBPACK FOOTER //
// ./src/js/scene/parts/components/TownSnow.js